import {
    FETCH_INSPECTOR_SHIFTS_REQUEST,
    FETCH_INSPECTOR_SHIFTS_SUCCESS,
    FETCH_INSPECTOR_SHIFTS_FAILURE,
} from '../action/inspectorShift';

const initialState = {
    shifts: [],
    loading: false,
    error: null
};

export default function inspectorShiftReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_INSPECTOR_SHIFTS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_INSPECTOR_SHIFTS_SUCCESS:
            return {
                ...state,
                loading: false,
                shifts: action.payload,
                error: null
            };
        case FETCH_INSPECTOR_SHIFTS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
} 